
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 300"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"fill":"#f8f9e8","stroke-width":"0"},attrs:{"d":"M194.58 167.48a93.225 93.225 0 0 0-3.96-9.82L137.88 27.12C132.52 11.34 117.58 0 100 0S68.98 10.24 63 24.8h-.02L7.86 161.08l-.36.88C2.66 173.68 0 186.52 0 200c0 55.22 44.78 100 100 100s100-44.78 100-100c0-11.38-1.9-22.32-5.42-32.52ZM100 260c-33.14 0-60-26.86-60-60s26.86-60 60-60 60 26.86 60 60-26.86 60-60 60Z"}})])
          )
        }
      }
    